import htm from 'htm'
import vhtml from 'vhtml'

const html = htm.bind(vhtml)

export default html